import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String,
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.pollId = setInterval(() => this.refresh(), this.intervalValue)
  }

  disconnect() {
    if (this.pollId) clearInterval(this.pollId)
  }

  refresh() {
    if (document.visibilityState !== "visible") return

    if (!this.element.src) {
      this.element.src = this.srcValue
    }

    try { this.element.reload() }
    catch(e) {
      console.warn(e)
    }
  }
}
